import { NEXTJS_REVALIDATE_PAGE_IN_SECONDS } from 'pages/index';
import { useThemeContext } from 'context/ThemeContext';
import { useEffect } from 'react';
import GenericPageLayout, {
  GenericPageLayoutProps,
} from 'components/general/genericPageLayout/GenericPageLayout';
import { parseGenericPage } from 'utils/parsers';
import style from './subscribePage.module.scss';
import CustomMetaData, {
  CustomMetaDataProps,
} from 'components/general/customMetaData/CustomMetaData';

type Props = { generic: GenericPageLayoutProps; metaData: CustomMetaDataProps };

const Subscribe = (props: Props) => {
  const { setTheme } = useThemeContext();

  useEffect(() => {
    setTheme('light');
  }, [setTheme]);

  return (
    <GenericPageLayout {...props.generic} blockStyles={style.blocks}>
      <CustomMetaData {...props.metaData} />
    </GenericPageLayout>
  );
};

export async function getStaticProps(context) {
  const genericProps: GenericPageLayoutProps = await parseGenericPage('/approach-page/', context);

  const props: Props = {
    generic: genericProps,
    metaData: {
      titleDefault: genericProps.originalResponse.title,
      title: genericProps.originalResponse.meta_title,
      description: genericProps.originalResponse.meta_description,
      image: genericProps.originalResponse.meta_image,
    },
  };
  // Pass data to the page via props
  return {
    props,
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: NEXTJS_REVALIDATE_PAGE_IN_SECONDS, // In seconds
  };
}

export default Subscribe;
